import {
  ComplexLossAPIFilters,
  ComplexLossDataResponse,
  ComplexLossFilters,
  ComplexLossFiltersRequest,
} from '@dispatch/shared/types';
import { getComplexLossDataPaginated } from '@dispatch/shared/services';
import { usePaginatedQuery } from '../api/usePaginatedQuery';

export const useGetComplexLossData = (
  filters: ComplexLossFilters,
  apiFilters: ComplexLossAPIFilters,
  enabled = true
) => {
  // need to flatten the filters that have multiOptionSelect to match the api
  const queryFilters: ComplexLossFiltersRequest = {
    ...filters,
    ...apiFilters,
    complexResources: filters?.complexResources?.map(
      (resource) => resource.value as string
    ),
  };

  const complexData = usePaginatedQuery<ComplexLossDataResponse>(
    ['complex-loss-data', queryFilters],
    (token) => getComplexLossDataPaginated(queryFilters, token),
    {
      enabled,
    }
  );

  const pages = complexData?.pages;

  return {
    ...complexData,
    data: pages?.[complexData.currentPageNumber]?.data,
  };
};
